export const MAX_BUFFERED = 10;

const buffer: string[] = [];
let installed = false;

export function pushError(message: string): void {
  buffer.push(message);
  if (buffer.length > MAX_BUFFERED) buffer.shift();
}

export function getErrors(): string[] {
  return [...buffer];
}

export function clearErrors(): void {
  buffer.length = 0;
}

/** Install global interceptors once. Safe to call multiple times. */
export function installConsoleBuffer(): void {
  if (installed || typeof window === 'undefined') return;
  installed = true;

  const originalError = console.error.bind(console);
  console.error = (...args: unknown[]) => {
    try {
      pushError(args.map(stringifyArg).join(' '));
    } catch {
      /* never let logging break the app */
    }
    originalError(...args);
  };

  window.addEventListener('error', (e) => {
    pushError(`${e.message} @ ${e.filename}:${e.lineno}`);
  });
  window.addEventListener('unhandledrejection', (e) => {
    pushError(`unhandledrejection: ${stringifyArg((e as PromiseRejectionEvent).reason)}`);
  });
}

function stringifyArg(a: unknown): string {
  if (a instanceof Error) return `${a.name}: ${a.message}`;
  if (typeof a === 'string') return a;
  try {
    return JSON.stringify(a);
  } catch {
    return String(a);
  }
}
